import './Badge.scss';
import React from 'react';

export const BadgeClass = {
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Success: 'success',
    Blue: 'blue',
    BlueOutline: 'blue outline'
};

export const Badge = ({ type, text, className, onClick }) => (
    <div className={`badge ${type} ${className}`} onClick={onClick}>
        {text}
    </div>
);
